import { render, staticRenderFns } from "./PickUpPage.vue?vue&type=template&id=55191d14&scoped=true&"
import script from "./PickUpPage.vue?vue&type=script&lang=js&"
export * from "./PickUpPage.vue?vue&type=script&lang=js&"
import style0 from "./PickUpPage.vue?vue&type=style&index=0&id=55191d14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55191d14",
  null
  
)

export default component.exports